import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UsersService } from '../../../../users.service';
import { Enums } from '../../../../../../configs/Enums';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-user-role-expanded-popover',
  templateUrl: './user-role-expanded-popover.component.html',
  styleUrls: ['./user-role-expanded-popover.component.scss'],
  standalone: false,
})
export class UserRoleExpandedPopoverComponent implements OnInit {
  @Input() userId;
  @Input() role;

  public userRoleExpanded;
  public backendError: string;
  public userRoleExpandedLoading: boolean;

  constructor(private usersService: UsersService) {}

  ngOnInit() {
    console.log(this);
  }

  getUserRoleExpandedData() {
    this.userRoleExpandedLoading = true;
    this.usersService
      .getUserRoleExpanded({
        user_id: this.userId,
        group_id: this.role.group.id,
      })
      .subscribe(
        (response) => {
          this.userRoleExpanded = response['data'];
          this.userRoleExpandedLoading = false;
        },
        (error) => {
          this.userRoleExpanded = null;
          this.backendError = Enums.errorCodes[Enums.errorCodesMaps['BACKEND_ERROR']];
          this.userRoleExpandedLoading = false;
        }
      );
  }

  toggleWithRole(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
      this.getUserRoleExpandedData();
    }
  }
}
